export enum ServicingRequestParams {
  lastName = 'lastName',
  recLoc = 'recLoc',
  scenario = 'scenario'
}
